import { CALL_API } from 'redux-api-middleware'

import getAccessToken from '../../../lib/utils/getAccessToken'

import { BASE_URL } from '../../../constants'

import { GET_REPORT, DATE, GP, VALUE, FILTER, SORT, MODULE } from './constants'
import { getDate } from './selectors'

/**
 * @param {import('moment').Moment} from
 * @param {import('moment').Moment} to
 * @param {string} lob
 */
export const fetchReport = (from, to, lob = '') => {
  const start_date = `start_date=${from}`
  const end_date = `end_date=${to}`
  const lob_id = lob ? `lob_id=${lob}` : ''
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/project-profits/report?${start_date}&${end_date}&${lob_id}`,
      method: 'GET',
      types: [GET_REPORT.REQUEST, GET_REPORT.SUCCESS, GET_REPORT.FAILURE],
      headers: {
        authorization: `bearer ${getAccessToken()}`,
      },
    },
  }
}

/**
 * Reset module's state
 */
export const resetModule = () => ({
  type: MODULE.RESET,
})

/**
 * @param {string} target
 * @param {import('moment').Moment} date
 * @returns {(dispatch: import('redux').Dispatch, getState: function) => Promise<void>}
 */
export const setDate = (target, date) => async (dispatch, getState) => {
  // updating date value
  dispatch({ type: DATE.SET_FIELD, payload: [target, date] })

  // getting new date value and then call api again
  const { from, to } = getDate(getState())
  await dispatch(fetchReport(from, to))
}

/**
 * @param {import('./model').GPType} gptype
 */
export const setGP = gptype => ({
  type: GP.SET,
  payload: gptype,
})

/**
 * @param {import('./model').ValueType} valuetype
 */
export const setValue = valuetype => ({
  type: VALUE.SET,
  payload: valuetype,
})

/**
 * @param {string} target
 * @param {string | null} value
 */
export const setFilter = (target, value) => ({
  type: FILTER.SET_FIELD,
  payload: [target, value],
})

/**
 * @param {string} target
 * @param {string | null} value
 */
export const setSort = (target, value) => ({
  type: SORT.SET_FIELD,
  payload: [target, value],
})



// WEBPACK FOOTER //
// ./src/pages/report/project-profit-sheet/actions.js